import { Stage } from './gfx/Stage';
import { Loader } from './ui/Loader';
import { Overlay } from './ui/Overlay';
import { useBootstrap } from './ui/useBootstrap';

export default function App() {
  useBootstrap();

  return (
    <main id="app">
      <Stage />
      <Overlay />
      {/* Last, so it covers both while the instrument is being warmed. */}
      <Loader />
    </main>
  );
}
